import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import * as aiimUtil from "../../../aiim/util/aiimUtil";

export function getPrompt(promptOptions,targetItem) {
  const i18n = Context.instance.i18n;
  const prompt = {};
  const subject = promptOptions.subject;
  const target = promptOptions.target;
  const subjectItems = promptOptions.subjectItems;
  const count = (subjectItems && subjectItems.length) || 0;

  let pattern, subjectItem, subjectName;
  if (count === 1) subjectItem = subjectItems[0];

  if (subject === "people") {
    if (count === 1) {
      subjectName = getPersonName(subjectItem);
    }
    if (target === "unit") {
      if (count === 1) {
        pattern = i18n.spaceplanner.people.assignTo.unit.promptSingle;
        prompt.text = pattern.replace("{name}",subjectName);
      } else {
        pattern = i18n.spaceplanner.people.assignTo.unit.promptMultiple;
        prompt.text = pattern.replace("{count}",count);
      }
    } else if (target === "hotdesk") {
      if (count === 1) {
        pattern = i18n.spaceplanner.people.assignTo.hotdesk.promptSingle;
        prompt.text = pattern.replace("{name}",subjectName);
      } else {
        pattern = i18n.spaceplanner.people.assignTo.hotdesk.promptMultiple;
        prompt.text = pattern.replace("{count}",count);
      }
    } else if (target === "hotel") {
      if (count === 1) {
        pattern = i18n.spaceplanner.people.assignTo.hotel.promptSingle;
        prompt.text = pattern.replace("{name}",subjectName);
      } else {
        pattern = i18n.spaceplanner.people.assignTo.hotel.promptMultiple;
        prompt.text = pattern.replace("{count}",count);
      }
    }

  } else if (subject === "units") {
    if (count === 1) {
      subjectName = getUnitName(subjectItem);
    }
    if (target === "person") {
      pattern = i18n.spaceplanner.units.assignTo.person.prompt;
      prompt.text = pattern.replace("{name}",subjectName);
    } else if (target === "hotdesk") {
      if (count === 1) {
        pattern = i18n.spaceplanner.units.assignTo.hotdesk.promptSingle;
        prompt.text = pattern.replace("{name}",subjectName);
      } else {
        pattern = i18n.spaceplanner.units.assignTo.hotdesk.promptMultiple;
        prompt.text = pattern.replace("{count}",count);
      }
    } else if (target === "hotel") {
      if (count === 1) {
        pattern = i18n.spaceplanner.units.assignTo.hotel.promptSingle;
        prompt.text = pattern.replace("{name}",subjectName);
      } else {
        pattern = i18n.spaceplanner.units.assignTo.hotel.promptMultiple;
        prompt.text = pattern.replace("{count}",count);
      }
    }

  } else if (subject === "hotdesk") {
    subjectName = getAreaName(subjectItem);
    if (target === "person") {
      pattern = i18n.spaceplanner.hotdeskAreas.assignTo.person.prompt;
      prompt.text = pattern.replace("{name}",subjectName);
    } else if (target === "unit") {
      pattern = i18n.spaceplanner.hotdeskAreas.assignTo.unit.prompt;
      prompt.text = pattern.replace("{name}",subjectName);
    }

  } else if (subject === "hotel") {
    subjectName = getAreaName(subjectItem);
    if (target === "person") {
      pattern = i18n.spaceplanner.hotelAreas.assignTo.person.prompt;
      prompt.text = pattern.replace("{name}",subjectName);
    } else if (target === "unit") {
      pattern = i18n.spaceplanner.hotelAreas.assignTo.unit.prompt;
      prompt.text = pattern.replace("{name}",subjectName);
    }
  }

  return prompt;
}

export function getUnassignPrompt(promptOptions) {
  //console.log("getPrompt.promptOptions",promptOptions)
  const i18n = Context.instance.i18n;
  const prompt = {};
  let count, pattern, subjectName, fromName;

  const subject = promptOptions.subject;
  let subjectItem = promptOptions.subjectItem;
  const subjectItems = promptOptions.subjectItems;
  if (!subjectItem && (subjectItems && subjectItems.length === 1)) {
    subjectItem = subjectItems[0];
  }
  if (subjectItem) {
    count = 1;
  } else  {
    count = (subjectItems && subjectItems.length) || 0;
  }

  const from = promptOptions.from;
  const fromItem = promptOptions.fromItem;

  if (subject === "person") {
    pattern = i18n.spaceplanner.unassignPrompt.unassignFrom;
    subjectName = getPersonName(subjectItem);
    fromName = promptOptions.fromName;
    if (!fromName && fromItem) {
      if (from === "unit") {
        fromName = getUnitName(fromItem);
      } else if (from === "hotdesk") {
        fromName = getAreaName(fromItem);
      } else if (from === "hotel") {
        fromName = getAreaName(fromItem);
      }
    }
    prompt.text = replaceSubjectTarget(pattern,subjectName,fromName);

  } else if (subject === "unit") {
    pattern = i18n.spaceplanner.unassignPrompt.unassignFrom;
    subjectName = getUnitName(subjectItem);
    fromName = promptOptions.fromName;
    if (!fromName && fromItem) {
      if (from === "hotdesk") {
        fromName = getAreaName(fromItem);
      } else if (from === "hotel") {
        fromName = getAreaName(fromItem);
      }
    }
    prompt.text = replaceSubjectTarget(pattern,subjectName,fromName);

  } else if (subject === "people") {
    pattern = i18n.spaceplanner.unassignPrompt.unassignPeople;
    prompt.text = replaceCount(pattern,count);

  } else if (subject === "units") {
    if (count === 1) {
      pattern = i18n.spaceplanner.unassignPrompt.unassignUnit;
      subjectName = getUnitName(subjectItem);
      prompt.text = replaceName(pattern,subjectName);
    } else {
      pattern = i18n.spaceplanner.unassignPrompt.unassignUnits;
      prompt.text = replaceCount(pattern,count);
    }

  } else if (subject === "hotdesk") {
    subjectName = getAreaName(subjectItem);
    pattern = i18n.spaceplanner.unassignPrompt.unassignArea;
    prompt.text = replaceTarget(pattern,subjectName);

  } else if (subject === "hotel") {
    subjectName = getAreaName(subjectItem);
    pattern = i18n.spaceplanner.unassignPrompt.unassignArea;
    prompt.text = replaceTarget(pattern,subjectName);
  }

  return prompt;
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

function getAreaName(areaItem) {
  return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_NAME);
}

function getPersonName(featureItem) {
  const attr = featureItem && featureItem.feature && featureItem.feature.attributes;
  return aiimUtil.getAttributeValue(attr,FieldNames.PEOPLE_FULLNAME);
}

function getUnitName(featureItem) {
  const attr = featureItem && featureItem.feature && featureItem.feature.attributes;
  return aiimUtil.getAttributeValue(attr,FieldNames.NAME);
}

function replaceCount(pattern,count) {
  return pattern.replace("{count}",count);
}

function replaceName(pattern,name) {
  return pattern.replace("{name}",name);
}

function replaceSubjectTarget(pattern,subjectName,targetName) {
  return pattern.replace("{subject}",subjectName).replace("{target}",targetName);
}

function replaceTarget(pattern,targetName) {
  return pattern.replace("{target}",targetName);
}
